import CouponDisplay from './CouponDisplay'

export default CouponDisplay;